import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4","key":"svg-0"}],["path",{"d":"M12 3c7.2 0 9 1.8 9 9c0 7.2 -1.8 9 -9 9c-7.2 0 -9 -1.8 -9 -9c0 -7.2 1.8 -9 9 -9","key":"svg-1"}]]

const IconSquareRoundedLetterR = createReactComponent('outline', 'square-rounded-letter-r', 'SquareRoundedLetterR', __iconNode);

export default IconSquareRoundedLetterR;